/**
 * @desc updateStatus
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierBoxUpdateStatusDto, options?: any) {
  return updateResponse(
    http(URL + `/sku/updateStatus`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
